import { ReactNode, useCallback, useState } from 'react';

import { AdCreativeDetails } from '../../../queries';
import { buildFileName } from '../utils/export';
import { fromSavedCreative } from '../utils/scene';
import { useSceneCapture } from './useSceneCapture';

interface CreativeDownloadApi {
  download: (details: AdCreativeDetails) => Promise<void>;
  /** Id kreacji, która właśnie się renderuje. */
  downloadingId: string | null;
  /** Ukryta plansza do wstawienia w drzewo. Bez niej nie ma czego renderować. */
  stage: ReactNode;
}

/**
 * Pobranie zapisanej kreacji bez wchodzenia do edytora. Plik powstaje z tej
 * samej sceny co w edytorze, w pełnej rozdzielczości formatu — miniatura
 * zapisana przy kreacji ma 480 px i nadaje się tylko do listy.
 */
export const useCreativeDownload = (): CreativeDownloadApi => {
  const capture = useSceneCapture();
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const download = useCallback(async (details: AdCreativeDetails) => {
    setDownloadingId(details.id);
    try {
      await capture.download(
        fromSavedCreative(details),
        buildFileName([details.name, `${details.width}x${details.height}`], 'png'),
      );
    } finally {
      setDownloadingId(null);
    }
  }, [capture]);

  return { download, downloadingId, stage: capture.stage };
};
